<template>
    <a-modal
        :visible="true"
        :closable="true"
        :footer="null"
        :width="700"
        @cancel="handleClose"
        centered
        wrapClassName="auto-rebalance-promo-modal"
    >
        <div class="auto-rebalance-promo">
            <div class="promo-header">
                <div class="icon-container">
                    <span class="material-icons">autorenew</span>
                </div>
                <h2>Otomatik Bakiye Yükleme</h2>
                <p class="subtitle">Sürekli bakiye yüklemekten yorulmadın mı? Otomatik bakiye yüklemeyi aktif et ve hizmet kesintisi yaşamadan devam et!</p>
            </div>

            <div class="promo-content">
                <div class="features-grid">
                    <div class="feature-card">
                        <div class="feature-icon red">
                            <span class="material-icons">notifications_active</span>
                        </div>
                        <div class="feature-text">
                            <strong>Bakiye Bittiğinde Fark Etme</strong>
                            <span>Hizmet kesilmeden otomatik yüklenir</span>
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon blue">
                            <span class="material-icons">refresh</span>
                        </div>
                        <div class="feature-text">
                            <strong>Sürekli Takip Etmeyin</strong>
                            <span>Sistem sizin yerinize halleder</span>
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="feature-icon green">
                            <span class="material-icons">check_circle</span>
                        </div>
                        <div class="feature-text">
                            <strong>Chatbot & WhatsApp Kesintisiz</strong>
                            <span>AI ve mesajlar hiç durmaz</span>
                        </div>
                    </div>
                </div>

                <div class="how-it-works">
                    <div class="steps-container">
                        <div class="step">
                            <div class="step-number">1</div>
                            <div class="step-content">
                                <strong>Eşik Değer</strong>
                                <span>Örn: 250 TL</span>
                            </div>
                        </div>
                        <div class="step-arrow">→</div>
                        <div class="step">
                            <div class="step-number">2</div>
                            <div class="step-content">
                                <strong>Hedef Bakiye</strong>
                                <span>Örn: 500 TL</span>
                            </div>
                        </div>
                        <div class="step-arrow">→</div>
                        <div class="step">
                            <div class="step-number">3</div>
                            <div class="step-content">
                                <strong>Otomatik</strong>
                                <span>Yükleme</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="promo-actions">
                    <a-button type="primary" size="large" @click="handleActivate" class="activate-btn">
                        <span class="btn-content">
                            <span class="material-icons">rocket_launch</span>
                            Hemen Başla
                        </span>
                    </a-button>
                    <a-button @click="handleClose" class="later-btn">
                        Daha Sonra
                    </a-button>
                </div>

                <div class="reminder-checkbox">
                    <a-checkbox v-model="dontShowAgain">
                        Bu mesajı tekrar gösterme
                    </a-checkbox>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: "AutoRebalancePromoModal",
    data() {
        return {
            dontShowAgain: false,
        };
    },
    methods: {
        handleActivate() {
            this.$emit("activate", this.dontShowAgain);
        },
        handleClose() {
            this.$emit("close", this.dontShowAgain);
        },
    },
};
</script>

<style scoped lang="scss">
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

@keyframes shimmer {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

.auto-rebalance-promo {
    animation: fadeInUp 0.5s ease-out;

    .promo-header {
        text-align: center;
        margin-bottom: 32px;
        padding: 0 20px;

        .icon-container {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 72px;
            height: 72px;
            background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%);
            border-radius: 20px;
            margin-bottom: 16px;
            box-shadow: 0 8px 24px rgba(255, 149, 0, 0.3);
            animation: pulse 2s ease-in-out infinite;

            .material-icons {
                font-size: 40px;
                color: white;
                animation: rotate 3s linear infinite;
            }
        }

        h2 {
            margin: 0 0 8px 0;
            font-size: 28px;
            font-weight: 700;
            background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .subtitle {
            margin: 0;
            font-size: 15px;
            color: #666;
            font-weight: 400;
        }
    }

    .promo-content {
        padding: 0 8px;

        .features-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
            margin-bottom: 32px;

            .feature-card {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                padding: 20px 12px;
                background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                border-radius: 16px;
                border: 1px solid #e8e8e8;
                transition: all 0.3s ease;
                animation: fadeInUp 0.6s ease-out backwards;

                &:nth-child(1) { animation-delay: 0.1s; }
                &:nth-child(2) { animation-delay: 0.2s; }
                &:nth-child(3) { animation-delay: 0.3s; }

                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
                    border-color: transparent;
                }

                .feature-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 12px;
                    transition: transform 0.3s ease;

                    .material-icons {
                        font-size: 28px;
                        color: white;
                    }

                    &.red {
                        background: linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%);
                        box-shadow: 0 4px 16px rgba(255, 77, 79, 0.3);
                    }

                    &.blue {
                        background: linear-gradient(135deg, #1890ff 0%, #0050b3 100%);
                        box-shadow: 0 4px 16px rgba(24, 144, 255, 0.3);
                    }

                    &.green {
                        background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
                        box-shadow: 0 4px 16px rgba(82, 196, 26, 0.3);
                    }
                }

                &:hover .feature-icon {
                    transform: scale(1.1);
                }

                .feature-text {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;

                    strong {
                        font-size: 14px;
                        font-weight: 600;
                        color: #3f3d56;
                    }

                    span {
                        font-size: 12px;
                        color: #999;
                    }
                }
            }
        }

        .how-it-works {
            margin-bottom: 32px;
            padding: 24px;
            background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
            border-radius: 16px;
            animation: fadeInUp 0.6s ease-out 0.4s backwards;

            .steps-container {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;

                .step {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 12px;

                    .step-number {
                        width: 40px;
                        height: 40px;
                        background: linear-gradient(135deg, #1890ff 0%, #0050b3 100%);
                        color: white;
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                        font-size: 18px;
                        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
                    }

                    .step-content {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;

                        strong {
                            font-size: 13px;
                            font-weight: 600;
                            color: #0050b3;
                        }

                        span {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }

                .step-arrow {
                    font-size: 24px;
                    color: #1890ff;
                    font-weight: bold;
                    margin: 0 4px;
                    margin-bottom: 30px;
                }
            }
        }

        .promo-actions {
            display: flex;
            flex-direction: column;
            gap: 12px;
            animation: fadeInUp 0.6s ease-out 0.5s backwards;

            .activate-btn {
                height: 52px;
                font-size: 16px;
                font-weight: 700;
                border: none;
                border-radius: 14px;
                background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%);
                box-shadow: 0 8px 24px rgba(255, 149, 0, 0.4);
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                    animation: shimmer 2s infinite;
                }

                .btn-content {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;

                    .material-icons {
                        font-size: 20px;
                    }
                }

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 32px rgba(255, 149, 0, 0.5);
                }

                &:active {
                    transform: translateY(0);
                }
            }

            .later-btn {
                height: 40px;
                font-size: 14px;
                color: #666;
                border-color: #e8e8e8;
                border-radius: 10px;
                transition: all 0.3s ease;

                &:hover {
                    color: #3f3d56;
                    border-color: #d9d9d9;
                    background: #fafafa;
                }
            }
        }

        .reminder-checkbox {
            margin-top: 20px;
            text-align: center;
            padding-top: 20px;
            border-top: 1px solid #e8e8e8;

            ::v-deep .ant-checkbox-wrapper {
                color: #999;
                font-size: 13px;
                transition: color 0.3s ease;

                &:hover {
                    color: #666;
                }
            }
        }
    }
}

::v-deep .auto-rebalance-promo-modal {
    .ant-modal-body {
        padding: 32px 24px 24px;
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            width: 48px;
            height: 48px;
            line-height: 48px;
            font-size: 18px;
            color: #999;
            transition: all 0.3s ease;

            &:hover {
                color: #3f3d56;
                transform: rotate(90deg);
            }
        }
    }
}
</style>

